import { getDataGridToolbarProps } from 'features/shared/utility/dataGridToolbarHelper';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Typography } from '@material-ui/core';
import { CommonDataGrid } from 'features/shared/components/table';
import { GRID_MODE } from 'features/shared/components/table/common-data-grid/const/dataGridConstants';
import FormSpinner from 'components/FormSpinner';
import { getPersonHistorySnapshots } from '../../services/userService';
import { executeApiAction } from 'features/shared/utility/apiHelper';
import { HISTORY_COLUMNS } from '../../constants/personHistorySnapshotsConstants';

const PersonHistorySnapshotsGrid = ({ personId }) => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({ personId, page: 0, pageSize: 25 });
  const page = pageState.personId === personId ? pageState.page : 0;
  const pageSize = pageState.personId === personId ? pageState.pageSize : 25;

  const handleGridStateChange = useCallback(
    ({ page: nextPage, pageSize: nextPageSize }) => {
      setPageState((previous) =>
        previous.personId === personId &&
        previous.page === nextPage &&
        previous.pageSize === nextPageSize
          ? previous
          : { personId, page: nextPage, pageSize: nextPageSize }
      );
    },
    [personId]
  );

  useEffect(() => {
    setRows([]);
    if (!personId) {
      setTotalRecords(0);
      setLoading(false);
      return;
    }

    let active = true;
    executeApiAction({
      dispatch,
      action: () =>
        getPersonHistorySnapshots(personId, {
          page: page + 1,
          pageSize,
        }),
      setLoading: (value) => {
        if (active) setLoading(value);
      },
      onSuccess: (response) => {
        if (!active) return;
        const data = Array.isArray(response)
          ? response
          : response?.data ?? (response?.ROWGUID ? [response] : []);
        const snapshots = Array.isArray(data) ? data : [data];
        setRows(snapshots);
        setTotalRecords(
          Number(response?.pagination?.totalSnapshots ?? response?.total ?? snapshots.length)
        );
      },
      onError: () => {
        if (active) setTotalRecords(0);
      },
    });

    return () => {
      active = false;
    };
  }, [dispatch, personId, page, pageSize]);

  return (
    <Box className="person-history-snapshots-grid">
      {loading && <FormSpinner />}
      <Box className="person-history-tab__toolbar">
        <Box className="person-history-tab__summary">
          <Typography variant="caption">{totalRecords} snapshots</Typography>
        </Box>
      </Box>
      <CommonDataGrid
        key={personId}
        rows={rows}
        getRowId={(row) => row.ROWGUID}
        columns={HISTORY_COLUMNS}
        mode={GRID_MODE.CLIENT}
        paginationMode={GRID_MODE.SERVER}
        serverSide={{ totalRecords, onStateChange: handleGridStateChange }}
        toolbar={getDataGridToolbarProps({
          showToolbar: true,
          showFilter: false,
          showColumnSelector: false,
          showExport: false,
          showPrint: false,
        })}
      />
    </Box>
  );
};

export default PersonHistorySnapshotsGrid;
